import { useState, useCallback } from 'react';

export const useImageValidation = (options = {}) => {
  // Default options: allow JPEG and PNG files, max file size 5MB.
  const { maxSize = 5 * 1024 * 1024, allowedTypes = ['image/jpeg', 'image/png'] } = options;
  const [error, setError] = useState('');

  const validateImage = useCallback((file) => {
    // Reset error if no file is provided
    if (!file) {
      setError('');
      return false;
    }

    // Check file type
    if (!allowedTypes.includes(file.type)) {
      setError('Unsupported file type. Only JPEG and PNG images are allowed.');
      return false;
    }

    // Check file size
    if (file.size > maxSize) {
      setError(`File size exceeds the limit of ${maxSize / (1024 * 1024)} MB.`);
      return false;
    }

    // If all validations pass, clear error and return true.
    setError('');
    return true;
  }, [allowedTypes, maxSize]);

  return { error, validateImage };
};


